export default __webpack_public_path__ + "static/404Image-6d618bfaa4f39baa239033d3b1ea025f.svg";